<template>
  <FormationDetailLayout
    lesson="Formation VTC pratique seule"
    back-item="formation-vtc"
    :hero-image="heroImage"
    hero-alt="highway-timelaps"
    hero-eyebrow="Préparation examen pratique VTC"
    hero-title="VTC PRATIQUE SEULE"
    :hero-stats="heroStats"
  >
    <template #main>
      <article class="formation-section formation-section--intro">
        <h2>VTC examen pratique seul</h2>

        <div class="formation-flow">
          <p>
            Nous vous proposons une <strong>formation taxi pratique</strong>
            intensive et ciblée pour vous préparer efficacement à l'examen
            <strong>T3P</strong> (<strong
              >Transport Public Particulier de Personnes</strong
            >). Notre <strong>formation "pratique seule" pour taxi</strong> se
            concentre spécifiquement sur les compétences nécessaires pour
            réussir l'<strong>épreuve pratique de l'examen T3P</strong>.
          </p>

          <p>
            Avec notre <strong>formation</strong>, vous bénéficierez de séances
            de conduite dédiées à la préparation de l'<strong
              >épreuve pratique</strong
            >. Nos formateurs expérimentés vous guideront et vous fourniront les
            conseils nécessaires pour maîtriser les techniques de conduite
            spécifiques à l'activité de transport de personnes.
          </p>

          <p>
            Nous mettons à votre disposition un véhicule adapté aux exigences de
            l'<strong>examen T3P</strong>, vous permettant de vous familiariser
            avec les conditions réelles de conduite lors de l'épreuve pratique.
            Vous serez entraîné à effectuer les manœuvres requises, à gérer les
            situations de circulation complexes et à assurer la sécurité des
            passagers et des autres usagers de la route.
          </p>

          <p>
            Notre objectif est de vous préparer de manière efficace et
            rigoureuse pour que vous puissiez réussir l'<strong
              >épreuve pratique de l'examen T3P</strong
            >. Nous mettons tout en œuvre pour vous aider à développer les
            compétences nécessaires et à gagner en confiance en tant que
            conducteur de
            <strong>transport public particulier de personnes</strong>.
          </p>

          <p>
            En choisissant notre <strong>formation pratique</strong> pour
            l'<strong>examen T3P</strong>, vous bénéficierez d'une préparation
            complète, axée sur les exigences spécifiques de l'<strong
              >épreuve pratique</strong
            >. Nous vous offrons l'opportunité de vous entraîner et de vous
            perfectionner dans un environnement encadré, afin d'augmenter vos
            chances de succès à l'<strong>examen</strong> et d'accéder à la
            <strong>profession de chauffeur taxi</strong>.
          </p>
        </div>
      </article>

      <ExamPrerequisitesCard mode="vtc" />
    </template>
  </FormationDetailLayout>
</template>

<script>
import ExamPrerequisitesCard from "@/components/formations/ExamPrerequisitesCard.vue";
import FormationDetailLayout from "@/components/formations/FormationDetailLayout.vue";
import { useMeta } from "vue-meta";

const heroImage = require("@/assets/pictures/examen-pratique-vtc.webp");
const heroStats = [
  { label: "Prix", value: "390€" },
  { label: "Durée", value: "3 séances de conduite" },
  { label: "Voiture de prêt", value: "pour l'examen" },
];

export default {
  name: "VtcPratiqueSeule",
  components: { ExamPrerequisitesCard, FormationDetailLayout },
  setup() {
    useMeta({
      title: " Examen pratique seule VTC",
      description: [
        {
          content:
            "Préparez-vous à l'examen pratique VTC avec notre formation complète. Évaluez vos compétences de conduite en circulation, la sécurité des passagers et des autres usagers de la route, ainsi que votre capacité à offrir un service client de qualité en tant que chauffeur VTC.",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.institut-taxi.fr/formation-vtc-pratique-seule",
        },
      ],
    });
  },
  data() {
    return {
      heroImage,
      heroStats,
    };
  },
};
</script>
